/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li4_LabelInputs */

const tr_mesafeli_s20_li4_label = /** @type {(inputs: Mesafeli_S20_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektronik Ticaret Bilgi Sistemi (ETBİS) Kaydı:`)
};

const en_mesafeli_s20_li4_label = /** @type {(inputs: Mesafeli_S20_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electronic Commerce Information System (ETBİS) registration:`)
};

const de_mesafeli_s20_li4_label = /** @type {(inputs: Mesafeli_S20_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintrag im Elektronischen Handelsinformationssystem (ETBİS):`)
};

const ru_mesafeli_s20_li4_label = /** @type {(inputs: Mesafeli_S20_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрация в Электронной системе информации о торговле (ETBİS):`)
};

/**
* | output |
* | --- |
* | "Electronic Commerce Information System (ETBİS) registration:" |
*
* @param {Mesafeli_S20_Li4_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li4_label = /** @type {((inputs?: Mesafeli_S20_Li4_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li4_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li4_label(inputs)
	if (locale === "de") return de_mesafeli_s20_li4_label(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li4_label(inputs)
	return tr_mesafeli_s20_li4_label(inputs)
});